export default {
      id: "i-file-pdf-new-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "img/sprite.svg#i-file-pdf-new",
      toString: function () {
        return this.url;
      }
    }